var routes = [{
  path: '/',
  component: function component() {
    return import('layouts/Default');
  },
  meta: {
    auth: true
  },
  children: [
  /*
   DASHBOARD
   */
  {
    name: 'dashboard',
    path: '',
    component: function component() {
      return import('pages/Dashboard');
    },
    meta: {
      auth: true,
      title: 'Dashboard'
    }
  },
  /*
  PURCHASE ORDERS
  */
  {
    name: 'purchaseorders',
    path: '/purchaseorders',
    component: function component() {
      return import('pages/purchaseorder/PurchaseOrderManagement');
    },
    meta: {
      auth: true,
      title: 'Purchase Orders',
      module: 'quotes'
    }
  }, {
    name: 'purchaseorder-create',
    path: '/purchaseorder/create',
    component: function component() {
      return import('pages/purchaseorder/PurchaseOrderCreate');
    },
    meta: {
      auth: true,
      title: 'New Purchase Order',
      module: 'quotes'
    }
  }, {
    name: 'purchaseorder-edit',
    path: '/purchaseorder/:id/:tab?',
    component: function component() {
      return import('pages/purchaseorder/PurchaseOrderEdit');
    },
    meta: {
      auth: true,
      title: 'Edit Purchase Order',
      module: 'quotes'
    }
  }, {
    name: 'purchaseorders-stock',
    path: '/purchaseorders-stock/:id',
    component: function component() {
      return import('pages/purchaseorder/PurchaseOrderReceiveStock');
    },
    meta: {
      auth: true,
      title: 'Purchase Orders',
      module: 'quotes'
    }
  },
  /*
  QUOTES
  */
  {
    name: 'quotes',
    path: '/quotes',
    component: function component() {
      return import('pages/quote/QuoteManagement');
    },
    meta: {
      auth: true,
      title: 'Quotes',
      module: 'quotes'
    }
  }, {
    name: 'quote-create',
    path: '/quote/create/:team_id?',
    component: function component() {
      return import('pages/quote/QuoteCreate');
    },
    meta: {
      auth: true,
      title: 'New Quote',
      module: 'quotes'
    }
  }, {
    name: 'quote-edit',
    path: '/quote/:id/:tab?',
    component: function component() {
      return import('pages/quote/QuoteEdit');
    },
    meta: {
      auth: true,
      title: 'Edit Quote',
      module: 'quotes'
    }
  },
  /*
  QUOTE SERVICE AGREEMENTS
  */
  {
    name: 'quote-service-agreements',
    path: '/quote-service-agreements',
    component: function component() {
      return import('pages/quoteserviceagreement/QuoteServiceAgreementManagement');
    },
    meta: {
      auth: true,
      title: 'Quote Service Agreements',
      module: 'quotes'
    }
  },
  /*
  QUOTE TEMPLATES
  */
  {
    name: 'quote-templates',
    path: '/quote-templates',
    component: function component() {
      return import('pages/quotetemplate/QuoteTemplateManagement');
    },
    meta: {
      auth: true,
      title: 'Quote Templates',
      module: 'quotes'
    }
  },
  /*
  USER TASK TEMPLATES
  */
  {
    name: 'usertask-templates',
    path: '/usertask-templates',
    component: function component() {
      return import('pages/usertasktemplate/UserTaskTemplateManagement');
    },
    meta: {
      auth: true,
      title: 'Task Templates',
      module: 'settings'
    }
  },
  /*
   PROFILE
   */
  {
    name: 'profile',
    path: '/profile',
    component: function component() {
      return import('pages/auth/Profile');
    },
    meta: {
      auth: true,
      title: 'Profile'
    }
  },
  /*
   MAIL
   */
  {
    name: 'email',
    path: '/email',
    component: function component() {
      return import('pages/email/EmailClient');
    },
    meta: {
      auth: true,
      title: 'Mail'
    }
  },
  /*
   CALENDAR
   */
  {
    name: 'calendar',
    path: '/calendar',
    component: function component() {
      return import('pages/qcalendar/Calendar');
    },
    meta: {
      auth: true,
      title: 'Calendar'
    }
  },
  /*
  CAMPAIGN
  */
  // manage
  {
    name: 'campaigns',
    path: '/campaigns',
    component: function component() {
      return import('pages/campaign/CampaignManagement');
    },
    meta: {
      auth: true,
      title: 'Campaigns',
      roles: ['admin']
    }
  },
  // create
  {
    name: 'campaign-create',
    path: '/campaign/create',
    component: function component() {
      return import('pages/campaign/CampaignCreate');
    },
    meta: {
      auth: true,
      title: 'Campaigns',
      roles: ['admin']
    }
  },
  // edit
  {
    name: 'campaign-edit',
    path: '/campaign/:id',
    component: function component() {
      return import('pages/campaign/CampaignEdit');
    },
    meta: {
      auth: true,
      title: 'Campaigns',
      roles: ['admin']
    }
  },
  /*
  EXTERNAL LINK CATEGORY
  */
  // manage
  {
    name: 'externallinkcategories',
    path: '/externallinkcategories',
    component: function component() {
      return import('pages/externallinkcategory/ExternalLinkCategoryManagement');
    },
    meta: {
      auth: true,
      title: 'Knowledge Base Categories',
      roles: ['admin']
    }
  },
  /*
  EXTERNAL LINK
  */
  // manage
  {
    name: 'externallinks',
    path: '/knowledgebase',
    component: function component() {
      return import('pages/externallink/ExternalLinkManagement');
    },
    meta: {
      auth: true,
      title: 'Knowledge Base Management',
      roles: ['admin']
    }
  },
  // search
  {
    name: 'externallink-search',
    path: '/knowledgebase/search',
    component: function component() {
      return import('pages/externallink/ExternalLinkSearch');
    },
    meta: {
      auth: true,
      title: 'Knowledge Base',
      roles: ['admin']
    }
  },
  /*
   INVOICES
   */
  {
    name: 'invoices',
    path: '/invoices',
    component: function component() {
      return import('pages/xero/XeroInvoiceManagement');
    },
    meta: {
      auth: true,
      title: 'Invoices'
    }
  },
  /*
  INVOICES LOG
  */
  {
    name: 'invoices-log',
    path: '/invoices-log',
    component: function component() {
      return import('pages/teaminvoicetemplatelog/TeamInvoiceTemplateLogManagement');
    },
    meta: {
      auth: true,
      title: 'Invoice Log'
    }
  },
  /*
  TEAM JOBS
  */
  // manage
  {
    name: 'teamjobs',
    path: '/teamjobs/:id?',
    component: function component() {
      return import('pages/teamjob/TeamJobManagement');
    },
    meta: {
      auth: true,
      title: 'Jobs',
      roles: ['admin'],
      module: 'jobs'
    }
  },
  // workbench
  {
    name: 'teamjobs-workbench',
    path: '/teamjobs-workbench/:tab?',
    component: function component() {
      return import('pages/teamjob/TeamJobWorkbench');
    },
    meta: {
      auth: true,
      title: 'Jobs',
      roles: ['admin'],
      module: 'jobs'
    }
  },
  /*
   NOTIFICATION TEMPLATES
   */
  // manage
  {
    name: 'notificationtemplates',
    path: '/emailtemplates/:module?',
    component: function component() {
      return import('pages/notificationtemplate/NotificationTemplateManagement');
    },
    meta: {
      auth: true,
      roles: ['admin'],
      title: 'Email Templates',
      module: 'settings'
    }
  },
  // create
  {
    name: 'notificationtemplate-create',
    path: '/emailtemplates/create/:module?',
    component: function component() {
      return import('pages/notificationtemplate/NotificationTemplateCreate');
    },
    meta: {
      auth: true,
      title: 'New Email Template',
      module: 'settings'
    }
  },
  // edit
  {
    name: 'notificationtemplate-edit',
    path: '/emailtemplates/:id',
    component: function component() {
      return import('pages/notificationtemplate/NotificationTemplateEdit');
    },
    meta: {
      auth: true,
      title: 'Edit Email Template',
      module: 'settings'
    }
  },
  /*
  NOTIFICATION
   */
  // send all
  {
    name: 'notification-sendall',
    path: '/notification/all',
    component: function component() {
      return import('pages/notification/SendNotificationAll');
    },
    meta: {
      auth: true,
      title: 'Send Notification to all',
      module: 'settings'
    }
  },
  /*
  CONTENT BLOCKS
  */
  // manage
  {
    name: 'contentblocks',
    path: '/contentblocks/management/:module?',
    component: function component() {
      return import('pages/contentblock/ContentBlockManagement');
    },
    meta: {
      auth: true,
      roles: ['admin'],
      title: 'Content Blocks'
    }
  },
  // create
  {
    name: 'contentblock-create',
    path: '/contentblocks/create/:module?/:id?',
    component: function component() {
      return import('pages/contentblock/ContentBlockCreate');
    },
    meta: {
      auth: true,
      title: 'New Content Block'
    }
  },
  // edit
  {
    name: 'contentblock-edit',
    path: '/contentblocks/:id',
    component: function component() {
      return import('pages/contentblock/ContentBlockEdit');
    },
    meta: {
      auth: true,
      title: 'Edit Content Block'
    }
  },
  /*
  CONTENT BLOCK TEMPLATES
  */
  // manage
  {
    name: 'contentblocktemplates',
    path: '/contentblocktemplates/management/:module?',
    component: function component() {
      return import('pages/contentblocktemplate/ContentBlockTemplateManagement');
    },
    meta: {
      auth: true,
      roles: ['admin'],
      title: 'Content Block Templates'
    }
  },
  // create
  {
    name: 'contentblocktemplate-create',
    path: '/contentblocktemplate/create/:module?',
    component: function component() {
      return import('pages/contentblocktemplate/ContentBlockTemplateCreate');
    },
    meta: {
      auth: true,
      title: 'New Content Block Template'
    }
  },
  // edit
  {
    name: 'contentblocktemplate-edit',
    path: '/contentblocktemplate/:id',
    component: function component() {
      return import('pages/contentblocktemplate/ContentBlockTemplateEdit');
    },
    meta: {
      auth: true,
      title: 'Content Block Template'
    }
  },
  /*
  PRODUCT SELLER
  */
  // manage
  {
    name: 'productsellers',
    path: '/productsuppliers',
    component: function component() {
      return import('pages/productseller/ProductSellerManagement');
    },
    meta: {
      auth: true,
      title: 'Product Suppliers',
      roles: ['admin'],
      module: 'settings'
    }
  },
  /*
  PRODUCTS
  */
  // manage
  {
    name: 'products',
    path: '/products',
    component: function component() {
      return import('pages/product/ProductManagement');
    },
    meta: {
      auth: true,
      title: 'Products',
      roles: ['admin']
    }
  },
  /*
   RESOURCES
   */
  // landing
  {
    name: 'resources',
    path: '/resources',
    component: function component() {
      return import('pages/resource/Landing');
    },
    meta: {
      auth: true,
      title: 'Resources'
    }
  },
  /*
   SETTINGS
   */
  // landing
  {
    name: 'settings',
    path: '/settings',
    component: function component() {
      return import('pages/Settings');
    },
    meta: {
      auth: true,
      roles: ['admin'],
      title: 'Settings',
      module: 'settings'
    }
  }, {
    name: 'settings-quote',
    path: '/settings/quote',
    component: function component() {
      return import('pages/quote/QuoteSetting');
    },
    meta: {
      auth: true,
      roles: ['admin'],
      title: 'Quote Settings',
      module: 'settings'
    }
  },
  /*
  REPORTING
  */
  // landing
  {
    name: 'reporting',
    path: '/reporting',
    component: function component() {
      return import('pages/Reporting');
    },
    meta: {
      auth: true,
      roles: ['admin'],
      title: 'Reporting',
      module: 'settings'
    }
  }, {
    name: 'team-gap-report',
    path: '/reporting/team/gap-report',
    component: function component() {
      return import('pages/team/reporting/TeamGapReport');
    },
    meta: {
      auth: true,
      roles: ['admin'],
      title: 'GAP Report',
      module: 'settings'
    }
  }, {
    name: 'team-managed-backups-report',
    path: '/reporting/team/managed-backups-report',
    component: function component() {
      return import('pages/team/reporting/TeamManagedBackupsReport');
    },
    meta: {
      auth: true,
      roles: ['admin'],
      title: 'Managed Backups Report',
      module: 'settings'
    }
  }, {
    name: 'team-managed-av-webroot-report',
    path: '/reporting/team/managed-av-webroot-report',
    component: function component() {
      return import('pages/team/reporting/TeamManagedAVWebrootReport');
    },
    meta: {
      auth: true,
      roles: ['admin'],
      title: 'Managed AV Webroot Report',
      module: 'settings'
    }
  }, {
    name: 'teamcampaign-report',
    path: '/teamcampaign/campaign-report',
    component: function component() {
      return import('pages/teamcampaign/reporting/TeamCampaignReport');
    },
    meta: {
      auth: true,
      roles: ['admin'],
      title: 'Campaign Report',
      module: 'settings'
    }
  },
  /*
  SALES REPORTING
  */
  // landing
  {
    name: 'sales-reporting',
    path: '/reporting/sales',
    component: function component() {
      return import('pages/reporting/ReportingSales');
    },
    meta: {
      auth: true,
      roles: ['admin'],
      title: 'Sales Reporting',
      module: 'settings'
    }
  },
  /*
   AUDIT TRAIL
   */
  // timeline
  {
    name: 'audit-history',
    path: '/audit/history',
    component: function component() {
      return import('pages/audit/AuditHistory');
    },
    meta: {
      auth: true,
      roles: ['admin'],
      title: 'Audit History',
      module: 'settings'
    }
  },
  /*
  COMPANY PROFILE
   */
  {
    name: 'company-profile',
    path: '/company-profile/view',
    component: function component() {
      return import('pages/companyprofile/CompanyProfileView');
    },
    meta: {
      auth: true,
      title: 'Company Profile'
    }
  }, {
    name: 'settings-company-profile',
    path: '/company-profile/edit',
    component: function component() {
      return import('pages/companyprofile/CompanyProfileEdit');
    },
    meta: {
      auth: true,
      roles: ['admin'],
      title: 'Company Profile',
      module: 'settings'
    }
  },
  /*
  SYSTEM SETTINGS SPLIT
   */
  {
    name: 'settings-branding',
    path: '/settings/branding',
    component: function component() {
      return import('pages/setting/SettingManagement');
    },
    meta: {
      auth: true,
      roles: ['admin'],
      title: 'System Settings',
      module: 'settings'
    }
  }, {
    name: 'teamonboardingtypes',
    path: '/teamonboardingtypes',
    component: function component() {
      return import('pages/teamonboardingtype/TeamOnboardingTypeManagement');
    },
    meta: {
      auth: true,
      roles: ['admin'],
      title: 'Onboarding & Request Forms',
      module: 'settings'
    }
  },
  /*
  INVENTORY
  */
  // manage
  {
    name: 'inventory',
    path: '/inventory',
    component: function component() {
      return import('pages/inventory/InventoryManagement');
    },
    meta: {
      auth: true,
      title: 'Inventory'
    }
  },
  /*
  CONTRACTS
  */
  // manage
  {
    name: 'contracts',
    path: '/contracts',
    component: function component() {
      return import('pages/contract/ContractManagement');
    },
    meta: {
      auth: true,
      title: 'Contracts',
      module: 'contracts'
    }
  },
  // create
  {
    name: 'contract-create',
    path: '/contract/create/:team_id?',
    component: function component() {
      return import('pages/contract/ContractCreate');
    },
    meta: {
      auth: true,
      title: 'New Contract',
      module: 'contracts'
    }
  },
  // edit
  {
    name: 'contract-edit',
    path: '/contract/:id/:section?',
    component: function component() {
      return import('pages/contract/ContractEdit');
    },
    meta: {
      auth: true,
      title: 'Edit Contract',
      module: 'contracts'
    }
  },
  /*
  CONTRACT RATES
  */
  // manage
  {
    name: 'contract-rates',
    path: '/contractrates',
    component: function component() {
      return import('pages/contractrate/ContractRateManagement');
    },
    meta: {
      auth: true,
      title: 'Contract Rates',
      module: 'settings'
    }
  },
  /*
  PROPOSALS
  */
  // manage
  {
    name: 'proposals',
    path: '/proposals',
    component: function component() {
      return import('pages/proposal/ProposalManagement');
    },
    meta: {
      auth: true,
      title: 'Proposals',
      module: 'proposals'
    }
  },
  // create
  {
    name: 'proposal-create',
    path: '/proposal/create',
    component: function component() {
      return import('pages/proposal/ProposalCreate');
    },
    meta: {
      auth: true,
      title: 'New Proposal',
      module: 'proposals'
    }
  },
  // edit
  {
    name: 'proposal-edit',
    path: '/proposal/:id',
    component: function component() {
      return import('pages/proposal/ProposalEdit');
    },
    meta: {
      auth: true,
      title: 'Edit Proposal',
      module: 'proposals'
    }
  },
  /*
  SERVICE TYPES
  */
  // manage
  {
    name: 'servicetypes',
    path: '/servicetypes',
    component: function component() {
      return import('pages/servicetype/ServiceTypeManagement');
    },
    meta: {
      auth: true,
      title: 'Service Types',
      module: 'settings'
    }
  },
  /*
  SKILLS
  */
  // manage
  {
    name: 'skills',
    path: '/skills',
    component: function component() {
      return import('pages/skill/SkillManagement');
    },
    meta: {
      auth: true,
      title: 'Skills',
      module: 'settings'
    }
  },
  /*
  USER SKILLS
  */
  // manage
  {
    name: 'userskills-management',
    path: '/skills/capabilities',
    component: function component() {
      return import('pages/userskill/UserSkillManagement');
    },
    meta: {
      auth: true,
      title: 'Tech Capabilities'
    }
  },
  /*
   SMS TEMPLATES
   */
  // manage
  {
    name: 'smstemplates',
    path: '/smstemplates',
    component: function component() {
      return import('pages/smstemplate/SmsTemplateManagement');
    },
    meta: {
      auth: true,
      title: 'SMS Templates',
      module: 'settings'
    }
  },
  /**
   * ACTIVITY FEED
   */
  {
    name: 'feed',
    path: '/feed',
    component: function component() {
      return import('pages/feed/FeedManagement');
    },
    meta: {
      auth: true,
      title: 'Activity Feed'
    }
  },
  /*
  XERO QUEUE
  */
  // manage
  {
    name: 'xeroqueue',
    path: '/xero/queue',
    component: function component() {
      return import('pages/xeroqueue/XeroQueueManagement');
    },
    meta: {
      auth: true,
      title: 'Xero Integration Queue',
      module: 'settings'
    }
  },
  /*
  SMS
  */
  // bulk send
  {
    name: 'sms-sendall',
    path: '/sms/all',
    component: function component() {
      return import('pages/sms/SendSmsAll');
    },
    meta: {
      auth: true,
      title: 'Bulk SMS',
      module: 'settings'
    }
  },
  // global log
  {
    name: 'smslog-all',
    path: '/sms/log',
    component: function component() {
      return import('pages/sms/SmsLogAll');
    },
    meta: {
      auth: true,
      title: 'SMS Log',
      module: 'settings'
    }
  },
  /*
  TEAMS
  */
  // manage
  {
    name: 'teams',
    path: '/customers/:type?',
    component: function component() {
      return import('pages/team/TeamManagement');
    },
    meta: {
      auth: true,
      title: 'Customers',
      roles: ['admin']
    }
  },
  // map
  {
    name: 'teams-map',
    path: '/maps/team/:team_id?',
    component: function component() {
      return import('pages/gmap/TeamMap');
    },
    meta: {
      auth: true,
      title: 'Customers',
      roles: ['admin']
    }
  },
  // create
  {
    name: 'team-create',
    path: '/customers/create/:type',
    component: function component() {
      return import('pages/team/TeamCreate');
    },
    meta: {
      auth: true,
      title: 'Customers',
      roles: ['admin']
    }
  },
  // lead import
  {
    name: 'team-import-lead-csv',
    path: '/leads/import/csv',
    component: function component() {
      return import('pages/team/TeamImportLeadCsv');
    },
    meta: {
      auth: true,
      title: 'Lead CSV Import',
      roles: ['admin']
    }
  },
  // manage products/services
  {
    name: 'teams-products-services',
    path: '/teamproductservices',
    component: function component() {
      return import('pages/teamproductservice/TeamProductServiceManagement');
    },
    meta: {
      auth: true,
      title: 'Customers Products/Services',
      roles: ['admin']
    }
  }, {
    name: 'teams-products-services-ingram',
    path: '/teamproductservices-ingram',
    component: function component() {
      return import('pages/teamproductservice/TeamProductServiceIngramManagement');
    },
    meta: {
      auth: true,
      title: 'Customers Products/Services - Ingram',
      roles: ['admin']
    }
  },
  // edit
  {
    name: 'team-home',
    path: '/customers/home/:id',
    component: function component() {
      return import('pages/team/TeamHome');
    },
    meta: {
      auth: true,
      title: 'Customers',
      roles: ['admin']
    },
    children: [
    // edit
    {
      name: 'team-dashboard',
      path: '/customers/dashboard/:id/:detailsTab?',
      component: function component() {
        return import('pages/team/TeamDashboard');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // documents
    {
      name: 'team-documents',
      path: '/customers/documents/:id',
      component: function component() {
        return import('pages/team/TeamDocuments');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // sms
    {
      name: 'team-sms',
      path: '/customers/sms/:id',
      component: function component() {
        return import('pages/team/TeamSms');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // sms
    {
      name: 'team-notifications',
      path: '/customers/notifications/:id',
      component: function component() {
        return import('pages/team/TeamNotifications');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // audit
    {
      name: 'team-audit',
      path: '/customers/audit/:id',
      component: function component() {
        return import('pages/team/TeamAudit');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // stock
    {
      name: 'team-product-stock',
      path: '/customers/products/:id',
      component: function component() {
        return import('pages/team/TeamProductStock');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // quotes
    {
      name: 'team-quotes',
      path: '/customers/quotes/:id',
      component: function component() {
        return import('pages/team/TeamQuotes');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // contracts
    {
      name: 'team-contracts',
      path: '/customers/contracts/:id',
      component: function component() {
        return import('pages/team/TeamContracts');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // proposals
    {
      name: 'team-proposals',
      path: '/customers/proposals/:id',
      component: function component() {
        return import('pages/team/TeamProposals');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // licenses
    {
      name: 'team-license',
      path: '/customers/licenses/:id',
      component: function component() {
        return import('pages/team/TeamLicense');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // invoices
    {
      name: 'team-invoices',
      path: '/customers/invoices/:id',
      component: function component() {
        return import('pages/team/TeamInvoices');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // opportunities
    {
      name: 'team-opportunities',
      path: '/customers/opportunities/:id',
      component: function component() {
        return import('pages/team/TeamOpportunity');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // passwords
    {
      name: 'team-passwords',
      path: '/customers/passwords/:id',
      component: function component() {
        return import('pages/team/TeamPassword');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // wan
    {
      name: 'team-wans',
      path: '/customers/wans/:id',
      component: function component() {
        return import('pages/team/TeamWan');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // domains
    {
      name: 'team-domains',
      path: '/customers/domains/:id',
      component: function component() {
        return import('pages/team/TeamDomain');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // jobs/projects
    {
      name: 'team-jobs',
      path: '/customers/jobs/:id',
      component: function component() {
        return import('pages/team/TeamJob');
      },
      meta: {
        auth: true,
        roles: ['admin'],
        module: 'jobs'
      }
    },
    // locations
    {
      name: 'team-locations',
      path: '/customers/locations/:id',
      component: function component() {
        return import('pages/team/TeamLocation');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // configurations
    {
      name: 'team-configurations',
      path: '/customers/configurations/:id',
      component: function component() {
        return import('pages/team/TeamConfiguration');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // form schema
    {
      name: 'team-formschemas',
      path: '/customers/formschemas/:id',
      component: function component() {
        return import('pages/team/TeamFormSchema');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // contacts
    {
      name: 'team-contacts',
      path: '/customers/contacts/:id',
      component: function component() {
        return import('pages/team/TeamContacts');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // backups
    {
      name: 'team-backups',
      path: '/customers/backups/:id',
      component: function component() {
        return import('pages/team/TeamBackup');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // campaigns
    {
      name: 'team-campaigns',
      path: '/customers/campaigns/:id',
      component: function component() {
        return import('pages/team/TeamCampaign');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // edit
    {
      name: 'team-edit',
      path: '/customers/edit/:id',
      component: function component() {
        return import('pages/team/TeamEdit');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // email
    {
      name: 'team-email',
      path: '/customers/email/:id',
      component: function component() {
        return import('pages/team/TeamEmail');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // access requests
    {
      name: 'team-access-requests',
      path: '/customers/accessrequests/:id',
      component: function component() {
        return import('pages/team/TeamAccessRequest');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // web presence
    {
      name: 'team-web-presence',
      path: '/customers/webpresence/:id',
      component: function component() {
        return import('pages/team/TeamWebPresence');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // onboarding
    {
      name: 'team-onboarding',
      path: '/customers/onboarding/:id',
      component: function component() {
        return import('pages/team/TeamOnboarding');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // product/service cancellation
    {
      name: 'team-product-service-cancellation',
      path: '/customers/productservicecancellation/:id',
      component: function component() {
        return import('pages/team/TeamProductServiceCancellation');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // tickets
    {
      name: 'team-tickets',
      path: '/customers/tickets/:id/:tab',
      component: function component() {
        return import('pages/team/TeamTickets');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    // porting
    {
      name: 'team-porting',
      path: '/customers/porting/:id',
      component: function component() {
        return import('pages/team/TeamPorting');
      },
      meta: {
        auth: true,
        roles: ['admin']
      }
    }]
  },
  /*
  BACKUPS LANDING
   */
  {
    name: 'teambackupbackup-landing',
    path: '/backups/landing',
    component: function component() {
      return import('pages/teambackupbackup/TeamBackupBackupLanding');
    },
    meta: {
      auth: true,
      title: 'Backups'
    }
  },
  /*
  SLAs
  */
  // manage
  {
    name: 'slas',
    path: '/slas',
    component: function component() {
      return import('pages/sla/SlaManagement');
    },
    meta: {
      auth: true,
      title: 'Slas',
      roles: ['admin'],
      module: 'settings'
    }
  },
  /*
  TAGS
  */
  // manage
  {
    name: 'tags',
    path: '/tags',
    component: function component() {
      return import('pages/tag/TagManagement');
    },
    meta: {
      auth: true,
      title: 'Tags',
      roles: ['admin'],
      module: 'settings'
    }
  },
  /*
  USER GROUPS
  */
  // manage
  {
    name: 'usergroups',
    path: '/usergroups',
    component: function component() {
      return import('pages/usergroup/UserGroupManagement');
    },
    meta: {
      auth: true,
      title: 'User Groups',
      roles: ['admin'],
      module: 'settings'
    }
  },
  /*
  ACCESS REQUEST TYPES
  */
  // manage
  {
    name: 'access-request-types',
    path: '/access-request-types',
    component: function component() {
      return import('pages/accessrequesttype/AccessRequestTypeManagement');
    },
    meta: {
      auth: true,
      title: 'Request & Approval Types',
      roles: ['admin'],
      module: 'settings'
    }
  },
  /*
  BYPASS REASONS
  */
  // manage
  {
    name: 'bypassreasons',
    path: '/bypassreasons',
    component: function component() {
      return import('pages/bypassreason/BypassReasonManagement');
    },
    meta: {
      auth: true,
      title: 'Bypass Reasons',
      roles: ['admin']
    }
  },
  /*
  STATUS REASONS
  */
  // manage
  {
    name: 'status-reasons',
    path: '/status-reasons',
    component: function component() {
      return import('pages/statusreason/StatusReasonManagement');
    },
    meta: {
      auth: true,
      title: 'Status Reasons',
      roles: ['admin']
    }
  },
  /*
  TICKETS
  */
  // manage
  {
    name: 'tickets',
    path: '/tickets/:type?',
    component: function component() {
      return import('pages/ticket/TicketManagement');
    },
    meta: {
      auth: true,
      title: 'Tickets',
      roles: ['admin'],
      module: 'tickets'
    }
  },
  // manage
  {
    name: 'tickets-maintenance',
    path: '/tickets-maintenance',
    component: function component() {
      return import('pages/ticket/TicketManagementMaintenance');
    },
    meta: {
      auth: true,
      title: 'Tickets',
      roles: ['admin'],
      module: 'tickets'
    }
  }, {
    name: 'tickets-alert',
    path: '/tickets-alert',
    component: function component() {
      return import('pages/ticket/TicketManagementAlert');
    },
    meta: {
      auth: true,
      title: 'Tickets',
      roles: ['admin'],
      module: 'tickets'
    }
  }, {
    name: 'tickets-deferred',
    path: '/tickets-deferred',
    component: function component() {
      return import('pages/ticket/TicketManagementDeferred');
    },
    meta: {
      auth: true,
      title: 'Tickets',
      roles: ['admin'],
      module: 'tickets'
    }
  },
  // overview
  {
    name: 'tickets-overview',
    path: '/tickets-overview',
    component: function component() {
      return import('pages/ticket/TicketOverview');
    },
    meta: {
      auth: true,
      title: 'Tickets',
      roles: ['admin'],
      module: 'tickets'
    }
  },
  // edit
  {
    name: 'ticket-edit',
    path: '/ticket/:id',
    component: function component() {
      return import('pages/ticket/TicketEdit');
    },
    meta: {
      auth: true,
      title: 'Ticket',
      roles: ['admin'],
      module: 'tickets'
    }
  },
  // time report
  {
    name: 'ticket-time-report',
    path: '/ticketreporting/time',
    component: function component() {
      return import('pages/ticket/reporting/TicketTimeReport');
    },
    meta: {
      auth: true,
      title: 'Ticket Timesheets',
      roles: ['admin'],
      module: 'tickets'
    }
  },
  // overview report
  {
    name: 'ticket-overview-report',
    path: '/ticketreporting/overview',
    component: function component() {
      return import('pages/ticket/reporting/TicketOverviewReport');
    },
    meta: {
      auth: true,
      title: 'Ticket Overview',
      roles: ['admin'],
      module: 'tickets'
    }
  },
  // overview report
  {
    name: 'ticket-merged-report',
    path: '/ticketreporting/merged',
    component: function component() {
      return import('pages/ticket/reporting/TicketMergedReport');
    },
    meta: {
      auth: true,
      title: 'Ticket Merged Report',
      roles: ['admin'],
      module: 'tickets'
    }
  },
  // unbillable
  {
    name: 'tickets-unbillable-report',
    path: '/tickets-unbillable-report',
    component: function component() {
      return import('pages/ticket/reporting/TicketUnbillableReport');
    },
    meta: {
      auth: true,
      title: 'Tickets - Unbillable Report',
      roles: ['admin'],
      module: 'tickets'
    }
  },
  // checkin report
  {
    name: 'ticket-checkin-report',
    path: '/ticketreporting/checkin',
    component: function component() {
      return import('pages/teamjobcheckin/reporting/TeamJobCheckinReport');
    },
    meta: {
      auth: true,
      title: 'Ticket Overview',
      roles: ['admin'],
      module: 'tickets'
    }
  },
  /*
  TEAM OPPORTUNITY TYPES
  */
  // manage
  {
    name: 'teamopportunity-types',
    path: '/teamopportunitytypes',
    component: function component() {
      return import('pages/teamopportunitytype/TeamOpportunityTypeManagement');
    },
    meta: {
      auth: true,
      title: 'Opportunity Types',
      roles: ['admin']
    }
  },
  /*
   USERS
   */
  // landing
  {
    name: 'users',
    path: '/users/:role',
    component: function component() {
      return import('pages/user/UserManagement');
    },
    meta: {
      auth: true,
      title: 'Users',
      roles: ['admin'],
      module: 'users'
    }
  }, {
    name: 'users-insights',
    path: '/insights',
    component: function component() {
      return import('pages/user/UserInsights');
    },
    meta: {
      auth: true,
      title: 'Staff Insights',
      roles: ['admin'],
      module: 'users'
    }
  },
  /*
  USER COMMISSIONS
  */
  // manage
  {
    name: 'usercommissions',
    path: '/commissions',
    component: function component() {
      return import('pages/usercommission/UserCommissionManagement');
    },
    meta: {
      auth: true,
      title: 'Commissions',
      roles: ['admin']
    }
  },
  /*
  USER TASKS
  */
  // manage
  {
    name: 'usertasks',
    path: '/tasks/:id?',
    component: function component() {
      return import('pages/usertask/UserTaskManagement');
    },
    meta: {
      auth: true,
      title: 'Tasks',
      roles: ['admin']
    }
  },
  /*
  USER TASK CATEGORIES
  */
  // manage
  {
    name: 'usertask-categories',
    path: '/usertaskcategories',
    component: function component() {
      return import('pages/usertaskcategory/UserTaskCategoryManagement');
    },
    meta: {
      auth: true,
      title: 'Task Categories',
      roles: ['admin']
    }
  },
  // category reporting
  {
    name: 'usertask-categories-reporting',
    path: '/usertaskcategories-reporting',
    component: function component() {
      return import('pages/usertaskcategory/reporting/UserTaskCategoryReporting');
    },
    meta: {
      auth: true,
      title: 'Task Category Reporting',
      roles: ['admin']
    }
  },
  // staff time overview
  {
    name: 'staff-time-overview',
    path: '/staff-time-overview',
    component: function component() {
      return import('pages/usertaskcategory/reporting/StaffTimeOverview');
    },
    meta: {
      auth: true,
      title: 'Staff Time Overview',
      roles: ['admin']
    }
  },
  /*
  ACHIEVEMENT TRACKS
  */
  // manage
  {
    name: 'achievement-tracks',
    path: '/achievementtracks',
    component: function component() {
      return import('pages/achievementtrack/AchievementTrackManagement');
    },
    meta: {
      auth: true,
      title: 'Achievement Tracks',
      roles: ['admin']
    }
  },
  /*
  ACHIEVEMENT TRACK USER
  */
  // status
  {
    name: 'achievement-status',
    path: '/achievements/status',
    component: function component() {
      return import('pages/achievementtrackuser/AchievementTrackUserStatus');
    },
    meta: {
      auth: true,
      title: 'Achievements',
      roles: ['admin']
    }
  },
  /*
  PRODUCTS / SERVICES
  */
  // manage
  {
    name: 'productservice',
    path: '/productservice',
    component: function component() {
      return import('pages/productservice/ProductServiceManagement');
    },
    meta: {
      auth: true,
      title: 'Products / Services',
      roles: ['admin']
    }
  },
  /*
  PRODUCT CATEGORY
  */
  // manage
  {
    name: 'productcategories',
    path: '/productcategories',
    component: function component() {
      return import('pages/productcategory/ProductCategoryManagement');
    },
    meta: {
      auth: true,
      title: 'Product Categories',
      roles: ['admin']
    }
  },
  /*
  INDUSTRY TYPE
  */
  // manage
  {
    name: 'industrytypes',
    path: '/industrytypes',
    component: function component() {
      return import('pages/industrytype/IndustryTypeManagement');
    },
    meta: {
      auth: true,
      title: 'Industry Types',
      roles: ['admin']
    }
  },
  /*
  TEAM LEAD TYPE
  */
  // manage
  {
    name: 'teamleadtypes',
    path: '/teamleadtypes',
    component: function component() {
      return import('pages/teamleadtype/TeamLeadTypeManagement');
    },
    meta: {
      auth: true,
      title: 'Team Lead Types',
      roles: ['admin']
    }
  },
  /*
  TEAM LEAD SOURCE
  */
  // manage
  {
    name: 'teamleadsources',
    path: '/teamleadsources',
    component: function component() {
      return import('pages/teamleadsource/TeamLeadSourceManagement');
    },
    meta: {
      auth: true,
      title: 'Team Lead Sources',
      roles: ['admin']
    }
  },
  /*
  TEAM LEAD TYPE
  */
  // manage
  {
    name: 'tasktemplates',
    path: '/tasktemplates',
    component: function component() {
      return import('pages/tasktemplate/TaskTemplateManagement');
    },
    meta: {
      auth: true,
      title: 'Checklists',
      roles: ['admin']
    }
  },
  /*
  TEAM MEETING TYPE
  */
  // manage
  {
    name: 'teammeetingtypes',
    path: '/teammeetingtypes',
    component: function component() {
      return import('pages/teammeetingtype/TeamMeetingTypeManagement');
    },
    meta: {
      auth: true,
      title: 'Team Meeting Types',
      roles: ['admin']
    }
  },
  /*
  FORMS
  */
  // manage
  {
    name: 'teamformchemamanagement-global',
    path: '/forms',
    component: function component() {
      return import('pages/teamformschema/TeamFormSchemaManagement');
    },
    meta: {
      auth: true,
      title: 'Forms',
      roles: ['admin']
    }
  },
  /*
  XERO SUBSCRIPTION INVOICES
  */
  {
    name: 'xero-repeating-invoices',
    path: '/xero-repeating-invoices',
    component: function component() {
      return import('pages/xero/reporting/XeroRepeatingInvoices');
    },
    meta: {
      auth: true,
      title: 'Xero Subscription Invoices',
      roles: ['admin'],
      module: 'financials'
    }
  },
  /*
  XERO TICKET INVOICES
  */
  {
    name: 'xero-ticket-invoice-preview',
    path: '/xero-ticket-invoice-preview',
    component: function component() {
      return import('pages/xero/reporting/XeroTicketInvoicePreview');
    },
    meta: {
      auth: true,
      title: 'Xero Ticket Invoice Preview',
      roles: ['admin'],
      module: 'financials'
    }
  },
  /*
  CUSTOMER PRODUCT STOCK
  */
  // Deployment Report
  {
    name: 'team-product-stock-report',
    path: '/teamproductstock/reporting',
    component: function component() {
      return import('pages/teamproductstock/reporting/TeamProductStockReport');
    },
    meta: {
      auth: true,
      roles: ['admin']
    }
  },
  /*
  CUSTOMER TIME
  */
  // Lead Reporting
  {
    name: 'bdm-reporting',
    path: '/lead/bdm/reporting',
    component: function component() {
      return import('pages/team/reporting/TeamLeadReporting');
    },
    meta: {
      auth: true,
      roles: ['admin']
    }
  },
  // Time Spent Report
  {
    name: 'team-time-spent-report',
    path: '/teamtimespent/reporting',
    component: function component() {
      return import('pages/team/reporting/TimeSpentReport');
    },
    meta: {
      auth: true,
      roles: ['admin']
    }
  }, {
    name: 'team-contact-verification-report',
    path: '/teamcontactverification/reporting',
    component: function component() {
      return import('pages/teamcontactverification/TeamContactVerificationManagement');
    },
    meta: {
      auth: true,
      roles: ['admin']
    }
  },
  /*
  CLAUDE AI
  */
  // Claude AI reporting
  {
    name: 'ai-reporting',
    path: '/ai/reporting',
    component: function component() {
      return import('pages/ai/AiReporting');
    },
    meta: {
      auth: true,
      roles: ['admin']
    }
  }]
},
// signin
{
  name: 'signin',
  path: '/signin',
  component: function component() {
    return import('pages/auth/SignIn');
  },
  meta: {
    title: 'Sign In'
  }
},
// verify email
{
  name: 'verify-email',
  path: '/verify/email/:code?',
  component: function component() {
    return import('pages/auth/VerifyEmail');
  },
  meta: {
    title: 'Verify Email'
  }
},
// password reset request
{
  name: 'password-reset-request',
  path: '/password/reset/request',
  component: function component() {
    return import('pages/auth/PasswordResetRequest');
  },
  meta: {
    title: 'Password Reset Request'
  }
},
// password reset process
{
  name: 'password-reset-process',
  path: '/password/reset/process/:code',
  component: function component() {
    return import('pages/auth/PasswordResetProcess');
  },
  meta: {
    title: 'Password Reset Process'
  }
},
// campaigns
{
  name: 'team-campaign-edit-page',
  path: '/campaigns/edit/:id',
  component: function component() {
    return import('pages/teamcampaign/TeamCampaignEditPage');
  },
  meta: {
    auth: true,
    roles: ['admin']
  }
},
/*
TFA
 */
// setup
{
  name: 'tfa-setup',
  path: '/tfa/setup',
  component: function component() {
    return import('pages/auth/TfaSetup');
  },
  meta: {
    title: 'Two-Factor Authentication Setup',
    auth: true
  }
},
// google
{
  name: 'tfa-google',
  path: '/tfa/google',
  component: function component() {
    return import('pages/auth/TfaGoogle');
  },
  meta: {
    title: 'Two-Factor Authentication',
    auth: true
  }
},
// sms
{
  name: 'tfa-sms',
  path: '/tfa/sms',
  component: function component() {
    return import('pages/auth/TfaSms');
  },
  meta: {
    title: 'Two-Factor Authentication',
    auth: true
  }
},
// reset
{
  name: 'tfa-reset-process',
  path: '/tfa/reset/process/:code',
  component: function component() {
    return import('pages/auth/TfaResetProcess');
  },
  meta: {
    title: 'Two-Factor Authentication'
  }
},
/*
 ERROR 401
 */
{
  name: 'error401',
  path: '/error401',
  component: function component() {
    return import('pages/Error401');
  },
  meta: {
    title: 'Permission Error'
  }
}];

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  routes.push({
    name: 'error404',
    path: '*',
    component: function component() {
      return import('pages/Error404');
    }
  });
}
export default routes;